import { defineComponent, computed } from 'vue';

var Size;
(function (Size) {
    Size["SMALL"] = "small";
    Size["MEDIUM"] = "medium";
    Size["LARGE"] = "large";
})(Size || (Size = {}));
var script = defineComponent({
    name: 'InfoTitle',
    props: {
        noMarginBottom: {
            type: Boolean,
            default: false,
        },
        isCaptionColor: Boolean,
        isTextColor: Boolean,
        size: {
            type: String,
            default: Size.SMALL,
        },
        uppercase: Boolean,
    },
    setup(props) {
        const classTitle = computed(() => {
            const names = [];
            if (!props.noMarginBottom) {
                names.push('InfoTitle--margin-bottom');
            }
            if (props.isCaptionColor)
                names.push('InfoTitle--caption-color');
            if (props.isTextColor)
                names.push('InfoTitle--text-color');
            if (props.uppercase)
                names.push('InfoTitle--uppercase');
            switch (props.size) {
                case Size.SMALL:
                    names.push('InfoTitle--small');
                    break;
                case Size.MEDIUM:
                    names.push('InfoTitle--medium');
                    break;
                case Size.LARGE:
                    names.push('InfoTitle--large');
            }
            return names;
        });
        return { classTitle };
    },
});

export { Size, script as default };
